import { create } from 'zustand'

export type AdminNotificationKind = 'order' | 'cancel' | 'cash' | 'reschedule' | 'kyc'

export interface AdminNotification {
  id: string
  kind: AdminNotificationKind
  title: string
  body?: string
  href?: string
  at: number
  read: boolean
}

interface NotificationState {
  notifications: AdminNotification[]
  unreadCount: number
  add: (n: Omit<AdminNotification, 'read'>) => void
  markAllRead: () => void
  clear: () => void
}

const MAX = 50

/**
 * In-memory feed for the Topbar bell. Populated by NotificationProvider from the
 * admin Socket.IO stream. Deduplicated by id so the same event can't double-add.
 */
export const useNotificationStore = create<NotificationState>((set) => ({
  notifications: [],
  unreadCount: 0,
  add: (n) =>
    set((state) => {
      if (state.notifications.some((x) => x.id === n.id)) return state
      const next = [{ ...n, read: false }, ...state.notifications].slice(0, MAX)
      return { notifications: next, unreadCount: state.unreadCount + 1 }
    }),
  markAllRead: () =>
    set((state) =>
      state.unreadCount === 0
        ? state
        : {
            notifications: state.notifications.map((x) => ({ ...x, read: true })),
            unreadCount: 0,
          },
    ),
  clear: () => set({ notifications: [], unreadCount: 0 }),
}))
